<script>
import useSharedData from "@/use/SharedData.js";
import {ref, watch} from "vue";
import axios from "axios";
import useSharedMethod from "@/use/SharedMethod";

export default {
    name: "StrTemplateAutocomplete",
    props: {
        value: Number,
        type: String,
        module: String,
        label: String,
        readonly: Boolean,
        rules: Array,
    },
    setup(props, {emit}) {
        const {loading, inputColor, backgroundColor} = useSharedData();
        const {transformFilterValues} = useSharedMethod();

        const template = ref(null);
        const templates = ref([]);

        watch(() => props.value, () => {
            template.value = props.value;
        }, {immediate: true});

        function save() {
            emit('input', template.value);
        }

        function findAll() {
            loading.value = true;
            axios.get('/templates', {
                params: transformFilterValues({
                    type: props.type,
                    module: props.module,
                })
            }).then((response) => {
                templates.value = response.data;
            }).finally(() => {
                loading.value = false;
            });
        }

        watch(() => props.module, () => {
            if (props.module)
                findAll();
        }, {immediate: true});


        return {
            loading,
            inputColor,
            backgroundColor,
            template,
            templates,
            save,
        }
    }
}
</script>

<template>
    <div>
        <v-autocomplete
            v-model="template"
            :label="label"
            :items="templates"
            item-value="id"
            item-text="name"
            outlined
            dense
            :clearable="!readonly"
            @input="save"
            :readonly="readonly"
            :color="inputColor"
            :background-color="backgroundColor"
            :rules="rules"
            hide-details="auto"
        ></v-autocomplete>

        <input type="hidden"/>
    </div>
</template>